import React, { useState, useRef, useEffect } from 'react';

export function HeaderSearch({ collapseSearch, lang, trads, onToggle, onSearch }) {
    const [searchTerm, setSearchTerm] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (!collapseSearch && inputRef.current) inputRef.current.focus();
    }, [collapseSearch]);

    const handleChange = (e) => setSearchTerm(e.target.value);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') onSearch?.(searchTerm);
    };

    const handleClickIcon = () => {
        onToggle?.();
        onSearch?.(searchTerm);
    };

    return (
        <div className={!collapseSearch ? 'search-form' : 'search-form-hidden'}>
            <input
                aria-label="Search"
                className={!collapseSearch ? 'search-input' : 'search-hidden'}
                placeholder={`${trads.buscar}...`}
                type="text"
                value={searchTerm}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                ref={inputRef}
            />
            <button
                className="button-no-style"
                onClick={handleClickIcon}
                type="button"
            >
                <i className="fa fa-search search-icon" aria-hidden="true" />
            </button>
        </div>
    );
}